import { Button } from '@/shadcn-ui/button';
import { cn } from '@/shadcn-ui/utils';
import CreditAgeSummary from './credit-age-summary';
import PreviewYourRatesDrawerDialog, {
  PreviewYourRatesDrawerDialogProps,
} from './preview-your-rates-drawer-dialog';

export interface CreditAgeChangeDrawerDialogProps
  extends PreviewYourRatesDrawerDialogProps {
  handleOpen: () => void;
  className?: string;
  creditAgeSummaryClassName?: string;
  alreadyQualified?: boolean;
}

export default function CreditAgeChangeDrawerDialog({
  open,
  handleOpen,
  handleClose,
  selectedCreditScoreId,
  selectedIsOver25,
  selectedAgeRangeId,
  creditScores,
  ageRanges,
  className,
  creditAgeSummaryClassName,
  alreadyQualified,
}: CreditAgeChangeDrawerDialogProps) {
  return (
    <>
      <Button
        type="button"
        variant="clear"
        className={cn('h-auto', className)}
        onClick={handleOpen}
      >
        <CreditAgeSummary
          selectedCreditScoreId={selectedCreditScoreId}
          selectedIsOver25={selectedIsOver25 ?? true}
          selectedAgeRangeId={selectedAgeRangeId}
          creditScores={creditScores}
          ageRanges={ageRanges}
          defaultText="Select your age and credit score to unlock plan selection"
          className={cn(
            'cursor-pointer underline decoration-flexcar-neutral50 decoration-dotted decoration-[2px] underline-offset-[4px] hover:text-flexcar-neutral1 hover:decoration-flexcar-blue50',
            creditAgeSummaryClassName
          )}
        />
      </Button>

      <PreviewYourRatesDrawerDialog
        selectedIsOver25={selectedIsOver25}
        selectedCreditScoreId={selectedCreditScoreId}
        creditScores={creditScores}
        ageRanges={ageRanges}
        selectedAgeRangeId={selectedAgeRangeId}
        open={open}
        handleClose={handleClose}
        alreadyQualified={alreadyQualified}
      />
    </>
  );
}
